import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Grid, InputAdornment } from "@mui/material";

import EsfirusIcon from "@components/ui/icons/EsfirusIcon";
import EsfirusTextInput from "@components/ui/Text-input/EsfirusTextInput";
import ModalNewObra from "@screens/NewParte/BBs/ModalNewObra/ModalNewObra";
import DatePickerUI from "@components/ui/DatePickerUI/DatePickerUI";
import { FormDataPedido } from "@components/FormParte/FormPedido";
import ModalNewProveedor, { Proveedor } from "@screens/NewParte/BBs/ModalNewProveedor/ModalNewProveedor";

import { Obra } from "@models/obra";
import { removeSelectedObra, updateSelectedObra } from "@store/slices/selectedObra";
import zoomIcon from "@assets/images/icons/zoomIcon.png";
import { configurationService } from "@services/configApp";

const HeaderFormPedido = (props: any) => {
  const { formData, setFormData, dateIsInTheFuture } = props;
  const { referenceToSave } = configurationService.getConfigLineasPedido();

  const dispatch = useDispatch()
  const selectedobra = useSelector((state) => (state as any).selectedobra).obra

  const [openObraModal, setOpenObraModal] = useState(false);
  const [openProveedorModal, setOpenProveedorModal] = useState(false)

  const selectObra = async (obra: Obra) => {
    const { Administracion } = obra;

    dispatch(removeSelectedObra());

    obra.tipo = Administracion ? 'A' : 'O';

    // Guardamos en reference el código del empleado de la empresa seleccionada según https://esfirus.atlassian.net/browse/PARTRAB-295?focusedCommentId=22588.
    obra.reference = obra.empleado?.toString() ?? ""

    dispatch(
      updateSelectedObra({
        ...selectedobra,
        ...obra,
      })
    );
  };

  return (
    <>
      <Grid container spacing={{ xs: 1, md: 4 }} >
        <Grid item xs={12} sm={6} md={3}>
          <label>Empresa</label>
          <EsfirusTextInput disabled fullWidth value={formData?.company?.Nombre} />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <label>Obra</label>
          <EsfirusTextInput
            fullWidth
            aria-readonly
            value={formData?.obra?.description || formData?.obra?.name || formData?.obra?.Descripcion}
            size="small"
            inputProps={{ readOnly: true }}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="start"
                  className="pointer"
                  onClick={() => {
                    if (formData?.lineas.length === 0) {
                      setOpenObraModal(true);
                    }
                  }}
                >
                  <EsfirusIcon path={zoomIcon} />
                </InputAdornment>
              ),
            }}
            disabled={!props.editable || formData?.lineas.length !== 0}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <label>Proveedor</label>
          <EsfirusTextInput
            fullWidth
            aria-readonly
            value={formData?.proveedor?.RazonSocial}
            size="small"
            inputProps={{ readOnly: true }}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="start"
                  className="pointer"
                  onClick={() => {
                    if (formData?.lineas.length === 0) {
                      setOpenProveedorModal(true);
                    }
                  }}
                >
                  <EsfirusIcon path={zoomIcon} />
                </InputAdornment>
              ),
            }}
            disabled={!props.editable || formData?.lineas.length !== 0}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <label>Empleado</label>
          <EsfirusTextInput
            fullWidth
            disabled
            value={formData?.employee || ""}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <label>Fecha</label>
          <DatePickerUI
            value={formData.date}
            disabled={!props.editable}
            handleChange={newDate => {
              const dateSelected = newDate ?? moment()
              setFormData({ ...formData, date: dateSelected })
            }}
          />
          {dateIsInTheFuture && (
            <label style={{ color: 'red', width: '100%', textAlign: 'center' }}>
              No se pueden crear partes a futuro
            </label>
          )}
        </Grid>

        {/* El campo reference lleva el nombre del empleado según especificación en https://esfirus.atlassian.net/browse/PARTRAB-295?focusedCommentId=22588 */}
        {(referenceToSave === 'custom' && props.editable) && <Grid item xs={12} sm={6} md={4}>
          <label>Referencia (Obligatorio)</label>
          <EsfirusTextInput
            fullWidth
            disabled={!props.editable || referenceToSave !== 'custom'}
            value={formData?.reference || ''}
            inputProps={{ maxlength: 13 }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormData((prevFormaData: FormDataPedido) => ({
                ...prevFormaData,
                reference: e.target.value
              }))
            }}
          />
        </Grid>}
      </Grid>

      {/* Modales de selección */}
      {
        openObraModal && <ModalNewObra
          open={openObraModal}
          setOpen={setOpenObraModal}
          selectObra={selectObra}
          onlyInternalCompany={true}
        />
      }
      {
        openProveedorModal && <ModalNewProveedor
          open={openProveedorModal}
          setOpen={setOpenProveedorModal}
          selectProveedor={(proveedor: Proveedor) => {
            setFormData({ ...formData, proveedor: proveedor })
          }}
        />
      }
    </>
  );
}

export default HeaderFormPedido